<template>
  <div
    id="app"
    v-loading.fullscreen="remoteDataLoading !== 0"
    element-loading-text="数据获取中"
  >
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
// import Cookies from "js-cookie";
export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState(["remoteDataLoading"])
  },
  methods: {},

  created() {
    // 公开页面无需登录
    if (this.$route.name === "notifyMessagePublic") {
      return;
    }
    let token = this.$getToken();
    if (token) {
      // console.log(token);
    } else {
      if (this.$route.path != "/login") {
        this.$router.replace({
          name: "login"
        });
      }
    }
    // console.log("this.$route.path=" + this.$route.path);

    if (token && this.$route.path != "/login") {
      //console.log("my init data");
      // this.$AllMachineModelInfoList;
      // this.$getAllAgentIDName();
      // this.$getAllVendorIDName();
      // this.$getAllShopIDName();
    }
  }
};
</script>

<style lang="less"></style>
